import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ClientSidebar from "../../components/ClientSidebar";
import { useAuth } from "@/contexts/AuthContext";
import { updateNotificationPrefs } from "@/lib/account";

function Toggle({ on, onClick }: { on: boolean; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`relative w-11 h-6 rounded-full transition-colors ${on ? "bg-ocean" : "bg-gray-200"}`}
      aria-pressed={on}
    >
      <span className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${on ? "right-1" : "left-1"}`} />
    </button>
  );
}

export default function PerfilNotificacionesPage() {
  const { t } = useTranslation("profile");
  const { user, refreshMe } = useAuth();

  const [email, setEmail] = useState(true);
  const [whatsApp, setWhatsApp] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    if (user) {
      setEmail(user.notifyByEmail);
      setWhatsApp(user.notifyByWhatsApp);
    }
  }, [user]);

  const dirty = user ? email !== user.notifyByEmail || whatsApp !== user.notifyByWhatsApp : false;

  const save = async () => {
    setSaving(true);
    setSaved(false);
    try {
      await updateNotificationPrefs(email, whatsApp);
      await refreshMe();
      setSaved(true);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-offwhite pt-14 md:pt-20 pb-12">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
            <ClientSidebar active="notifications" />
            <div className="flex-1 min-w-0">
              <div className="bg-white rounded-2xl border border-gray-100 p-5 md:p-6">
                <h1 className="text-lg font-bold text-charcoal mb-6">{t("profile.notifications", { defaultValue: "Notificaciones" })}</h1>
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm font-medium text-charcoal">{t("profile.notifEmail")}</p>
                      <p className="text-xs text-gray-400">{t("profile.notifEmailDesc")}</p>
                    </div>
                    <Toggle on={email} onClick={() => { setEmail((v) => !v); setSaved(false); }} />
                  </div>
                  <div className="flex items-center justify-between border-t border-gray-100 pt-4">
                    <div>
                      <p className="text-sm font-medium text-charcoal">{t("profile.notifWhatsApp")}</p>
                      <p className="text-xs text-gray-400">{t("profile.notifWhatsAppDesc")}</p>
                    </div>
                    <Toggle on={whatsApp} onClick={() => { setWhatsApp((v) => !v); setSaved(false); }} />
                  </div>
                </div>
                <div className="mt-6 flex items-center gap-3">
                  <button
                    onClick={save}
                    disabled={!dirty || saving}
                    className="bg-ocean text-white text-sm font-medium px-5 py-2 rounded-full hover:bg-ocean/90 disabled:opacity-50"
                  >
                    {saving ? t("profile.saving") : t("profile.save")}
                  </button>
                  {saved && <span className="text-xs text-emerald-600">{t("profile.prefsSaved")}</span>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
